import { CaretRightOutlined } from "@ant-design/icons";
import classNames from "classnames";
import type { ReactNode } from "react";

type MobileNavGroupProps = {
  title: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export function MobileNavGroup({
  title,
  open,
  onToggle,
  children,
}: MobileNavGroupProps) {
  return (
    <div className="border-b border-yoyo-border/60 last:border-b-0">
      {/* 分组标题（点击展开/收起） */}
      <button
        type="button"
        className="flex w-full items-center justify-between px-4 py-4"
        onClick={onToggle}
        aria-expanded={open}
      >
        <span className="text-[20px] font-bold text-yoyo-text">{title}</span>
        <CaretRightOutlined
          className={classNames(
            "text-xs text-yoyo-secondary transition-transform duration-200",
            open && "rotate-90",
          )}
        />
      </button>
      {/* 展开内容区 */}
      <div
        className={classNames(
          "grid transition-[grid-template-rows] duration-200",
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
        )}
      >
        <div className="overflow-hidden">
          <div className="border-t border-yoyo-border/40 bg-yoyo-muted/25 px-4 pb-4 pt-1">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
